declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage(data: string): void;
    };
  }
}

export default class HealthForceGoApp {
  public static dismiss() {
    this.postMessage({
      action: 'dismiss',
    });
  }

  public static goBack() {
    this.postMessage({
      action: 'goBack',
    });
  }

  public static openExternalURL(url: string) {
    window.open(`${url}#external`, '_blank');
  }

  private static postMessage(data: {}) {
    console.info(`ReactNativeWebView.postMessage(${JSON.stringify(data)})`);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  }
}
